import "./App.css";
import Weather from "./Weather";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather dafaultCity="São Paulo" />
        <p>
          This project was coded by Sabrina Onishi and is{" "}
          <a
            href="https://github.com/So0703/react-weather-app"
            target="_blank"
            rel="noopener noreferrer"
          >
            Open-Source on GitHub
          </a>
        </p>
      </div>
    </div>
  );
}
